import React from "react";
import {useBrandExampleImages} from "data/access/survey-question-pages/examples-of-brands";
import Loading from "components/Loading";
import {assertNoError} from "helpers/asserts";
import {surveyQuestionPath} from "hooks/page-navigation/survey";
import {useNavigate} from "react-router-dom";

export const ExamplesOfBrandImages = () => {
  const [brandExampleImages, brandExampleImagesLoading, brandExampleImagesError] = useBrandExampleImages();
  assertNoError(brandExampleImagesError);
  if (brandExampleImagesLoading) {
    return <Loading className={"my-16"} loadingText={"Loading Images..."}/>;
  }
  if (brandExampleImages === null) {
    return <></>;
  }
  return <div className={"flex flex-col md:flex-row my-20 md:justify-center items-center"}>
    <div className={""}>
      <img src={brandExampleImages[0]} alt={brandExampleImages[0]} width={240}/>
    </div>
    <div className={"border-x-3 border-x-neutral-50 px-8 mx-8"}>
      <img src={brandExampleImages[1]} alt={brandExampleImages[1]} width={240}/>
    </div>
    <div className={""}>
      <img src={brandExampleImages[2]} alt={brandExampleImages[2]} width={240}/>
    </div>
  </div>
}

export const FormattedQuestion = () => {
  const navigate = useNavigate();

  const physicalProductPageUrl = surveyQuestionPath(
      "canva-assets",
      "all-features",
      "what-makes-you-special",
      "product-description-words",
  )

  return <div className={"text-center"}>
    <span className={"text-xl font-bold"}>Not what you expected?</span>
    <br/>
    <span
        className={"text-xl text-neutral-500"}
    >
      Branding Compass' guidance and recommendations come from branding experts with years of experience developing brands.
      If your brand traits don't feel right to you, <a onClick={() => navigate(physicalProductPageUrl)}>
      <span className={"text-bc-blue underline cursor-pointer"}>go back and try different words</span>
    </a> to describe how you want to visualize your brand.
    </span>
  </div>
}
